'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var TextField = require('@material-ui/core/TextField');
var InputAdornment = require('@material-ui/core/InputAdornment');
var IconButton = require('@material-ui/core/IconButton');
var Popover = require('@material-ui/core/Popover');
var CalendarPicker = require('@material-ui/lab/CalendarPicker');
var DatePicker = require('@material-ui/lab/DatePicker');
var luxon = require('luxon');
var CalendarTodayIcon = require('@material-ui/icons/CalendarToday');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var TextField__default = /*#__PURE__*/_interopDefaultLegacy(TextField);
var InputAdornment__default = /*#__PURE__*/_interopDefaultLegacy(InputAdornment);
var IconButton__default = /*#__PURE__*/_interopDefaultLegacy(IconButton);
var Popover__default = /*#__PURE__*/_interopDefaultLegacy(Popover);
var CalendarPicker__default = /*#__PURE__*/_interopDefaultLegacy(CalendarPicker);
var DatePicker__default = /*#__PURE__*/_interopDefaultLegacy(DatePicker);
var CalendarTodayIcon__default = /*#__PURE__*/_interopDefaultLegacy(CalendarTodayIcon);

var _excluded = ["inputFormat", "displayFormat", "value", "onChange", "disablePicker", "hasDialog", "DatePickerProps", "disabled"];
var DEFAULT_FORMAT = luxon.DateTime.DATE_MED;
var monthFirstFormats = ['M/d/yy', 'M/d/yyyy', 'M/dd/yy', 'M/dd/yyyy', 'MM/d/yy', 'MM/d/yyyy', 'MM/dd/yy', 'MM/dd/yyyy'];
var dayFirstFormats = ['d/M/yy', 'd/M/yyyy', 'dd/M/yy', 'dd/M/yyyy', 'd/MM/yy', 'd/M/yyyy', 'dd/MM/yy', 'dd/MM/yyyy'];
/** Convert an input string to a DateTime value */

function parseInputValue(inputValue, inputFormat) {
  if (!inputValue) {
    return null;
  }

  var formats = inputFormat === 'month-first' ? monthFirstFormats : dayFirstFormats;

  for (var format of formats) {
    var parsedValue = luxon.DateTime.fromFormat(inputValue, format);

    if (!parsedValue.invalid) {
      return parsedValue;
    }
  }

  return null;
}
/** Convert a DateTime value to an input string */


function getInputValue(value, inputFormat) {
  if (!value) {
    return '';
  }

  var format = inputFormat === 'month-first' ? 'M/d/yyyy' : 'd/M/yyyy';
  return value.toFormat(format);
}

function maskInputValue() {
  var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var sections = inputValue.split('/').slice(0, 3); // If the user types an extra digit we will assume they want
  // to continue typing to the next section without wanting to
  // type the backslash.

  var carryOver = '';
  var parsedSections = sections.map((section, index) => {
    var digits = section.replaceAll(/\D/g, ''); // Capture any excess digits and store in the `carryOver`

    carryOver = digits.substring(2, 3);
    return digits.substring(0, index === 2 ? 4 : 2).replaceAll(/\D/g, '');
  }); // Only add the carryOver if we are on the month or day sections.

  if (carryOver && parsedSections.length < 3) {
    parsedSections.push(carryOver);
  }

  return parsedSections.join('/');
}

var DateField = _ref => {
  var {
    inputFormat = 'month-first',
    displayFormat = DEFAULT_FORMAT,
    value,
    onChange: _onChange,
    disablePicker = false,
    hasDialog = false,
    DatePickerProps = {},
    disabled = false
  } = _ref,
      textFieldProps = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  var [isEditing, setIsEditing] = React__namespace.useState(false);
  var [inputValue, setInputValue] = React__namespace.useState('');
  var [pickerIsOpen, setPickerIsOpen] = React__namespace.useState(false);
  var ref = React__namespace.useRef();
  var pickerRef = React__namespace.useRef();
  var displayValue = value ? value.toLocaleString(displayFormat) : '';

  function handleInputChange(event) {
    if (isEditing) {
      setInputValue(maskInputValue(event.target.value));
    }
  }

  function handleFocus() {
    setIsEditing(true);
  }

  function handleInputBlur() {
    if (!pickerIsOpen) {
      setIsEditing(false);
      var newValue = parseInputValue(inputValue, inputFormat);

      _onChange(newValue);
    }
  }

  function handleKeyDown(event) {
    if (event.key === 'Enter') {
      var newValue = parseInputValue(inputValue, inputFormat);

      if (newValue || !inputValue) {
        _onChange(newValue);
      }
    }

    if (event.key === 'ArrowDown') {
      setPickerIsOpen(true);
    }
  }

  React__namespace.useEffect(() => {
    setInputValue(getInputValue(value, inputFormat));
  }, [value]);
  React__namespace.useEffect(() => {
    var _pickerRef$current;

    (_pickerRef$current = pickerRef.current) === null || _pickerRef$current === void 0 ? void 0 : _pickerRef$current.focus();
  }, [pickerRef]);
  return /*#__PURE__*/React__namespace.createElement("div", {
    style: {
      position: 'relative'
    },
    ref: ref
  }, /*#__PURE__*/React__namespace.createElement(TextField__default['default'], _rollupPluginBabelHelpers['extends']({}, textFieldProps, {
    disabled: disabled,
    value: isEditing ? inputValue : displayValue,
    onChange: handleInputChange,
    onFocus: handleFocus,
    onBlur: handleInputBlur,
    onKeyDown: handleKeyDown,
    InputProps: _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, textFieldProps.InputProps), {}, {
      endAdornment: !disablePicker && /*#__PURE__*/React__namespace.createElement(InputAdornment__default['default'], {
        position: "end"
      }, /*#__PURE__*/React__namespace.createElement(IconButton__default['default'], {
        disabled: disabled,
        onClick: () => setPickerIsOpen(!pickerIsOpen),
        color: pickerIsOpen ? 'primary' : 'default'
      }, /*#__PURE__*/React__namespace.createElement(CalendarTodayIcon__default['default'], null)))
    })
  })), pickerIsOpen && hasDialog && /*#__PURE__*/React__namespace.createElement(DatePicker__default['default'], _rollupPluginBabelHelpers['extends']({
    allowKeyboardControl: true
  }, DatePickerProps, {
    open: true,
    onClose: () => setPickerIsOpen(false),
    date: value,
    onChange: newValue => {
      _onChange(newValue);

      setPickerIsOpen(false);
    },
    renderInput: () => ""
  })), !hasDialog && /*#__PURE__*/React__namespace.createElement(Popover__default['default'], {
    open: pickerIsOpen,
    onClose: () => setPickerIsOpen(false),
    anchorEl: ref.current,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    style: {
      marginTop: 8
    }
  }, /*#__PURE__*/React__namespace.createElement(CalendarPicker__default['default'], _rollupPluginBabelHelpers['extends']({
    allowKeyboardControl: true
  }, DatePickerProps, {
    date: value,
    onChange: newValue => {
      _onChange(newValue);

      setPickerIsOpen(false);
    },
    ref: pickerRef
  }))));
};
DateField.propTypes = {
  /** Input style when using the keyboard. */
  inputFormat: index.oneOf(['month-first', 'day-first']),

  /** DateTime formating object. */
  displayFormat: index.object,

  /** Luxon DateTime. */
  value: index.object,

  /** Callback when date value is changed. */
  onChange: index.func,

  /** If `true`, the picker element will be hidden. */
  disablePicker: index.bool,

  /** If `true` the picker element will be displayed in a Dialog component. */
  hasDialog: index.bool,

  /** Props passed to the DatePicker component */
  DatePickerProps: index.object,

  /** If `true`, the field is disabled. */
  disabled: index.bool
};

exports.DEFAULT_FORMAT = DEFAULT_FORMAT;
exports.DateField = DateField;
exports.default = DateField;
